import React, { useState, useCallback, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { PlusCircle, Trash2 } from "lucide-react";
import SignerStampRow from "./SignerStampRow";
export interface SignerStamp {
  id: string;
  user: {
    id: string;
    name: string;
  } | null;
  role: {
    id: string;
    name: string;
  } | null;
}
export default function DynamicSignerStampList({
  rows,
  setRows,
  referenceOptions,
  institutionId
}: {
  rows: SignerStamp[];
  referenceOptions?: {
    value: string;
    label: string;
    type: "reference";
  }[];
  setRows: (rows: SignerStamp[]) => void;
  institutionId: string;
}) {
  const addRow = useCallback(() => {
    setRows(rows.concat({
      id: Date.now().toString(),
      user: null,
      role: null
    }));
  }, [rows]);
  const removeRow = useCallback((id: string) => {
    setRows(rows.filter(row => row.id !== id));
  }, [rows]);
  const updateRow = useCallback((id: string, field: "user" | "role", value: {
    id: string;
    name: string;
  } | null) => {
    setRows(rows.map(row => row.id === id ? {
      ...row,
      [field]: value
    } : row));
  }, [rows]);
  return <div className="w-full space-y-4" data-sentry-component="DynamicSignerStampList" data-sentry-source-file="DynamicSignerStampList.tsx">
      {rows.map((row, index) => <SignerStampRow key={row.id} row={row} onUpdate={updateRow} institutionId={institutionId} referenceOptions={referenceOptions} onRemove={rows.length > 1 ? () => removeRow(row.id) : undefined} />)}
      <Button onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      addRow();
    }} className="w-full" data-sentry-element="Button" data-sentry-source-file="DynamicSignerStampList.tsx">
        <PlusCircle className="mr-2 h-4 w-4" data-sentry-element="PlusCircle" data-sentry-source-file="DynamicSignerStampList.tsx" /> Add Signer
      </Button>
    </div>;
}